import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=0bdf223d&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=0bdf223d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf223d",
  null
  
)

export default component.exports